import { GET_HOSPITALS, SET_HOSPITALS } from '../actions/actionTypes';

const initialState = {
  list: [],
  isLoading: false,
  isLoaded: false
};

const groupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_HOSPITALS:
      return { ...state, isLoading: true };
    case SET_HOSPITALS:
      return {
        ...state,
        list: action.hospitals,
        isLoaded: true,
        isLoading: false
      };
    default:
      return state;
  }
};

export default groupsReducer;
